/**
 * Lightweight runtime perf helpers: pause offscreen / hidden media,
 * and respect prefers-reduced-motion.
 */
(function () {
  'use strict';

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function videos() {
    return document.querySelectorAll('video');
  }

  function pauseAllVideos() {
    videos().forEach(function (v) {
      try {
        if (!v.paused) {
          v.dataset.pjWasPlaying = '1';
          v.pause();
        }
      } catch (err) {}
    });
  }

  function resumeMarkedVideos() {
    if (reduceMotion) return;
    videos().forEach(function (v) {
      if (v.dataset.pjWasPlaying === '1') {
        v.dataset.pjWasPlaying = '0';
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pauseAllVideos();
    else resumeMarkedVideos();
  });

  function forceMutedPlay(v) {
    try {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.removeAttribute('controls');
      if (v.autoplay || v.dataset.pjKeepPlaying === '1') {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    } catch (err) {}
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (!(v instanceof HTMLVideoElement)) return;
          if (reduceMotion) {
            v.pause();
            return;
          }
          // Hero / marked background videos should keep playing
          if (
            v.dataset.pjKeepPlaying === '1' ||
            v.classList.contains('myVideo') ||
            v.classList.contains('password-video') ||
            v.classList.contains('pj-collection-media__video') ||
            v.classList.contains('pj-product-videos__video')
          ) {
            if (entry.isIntersecting) forceMutedPlay(v);
            return;
          }
          if (entry.isIntersecting && entry.intersectionRatio > 0.15) {
            if (v.dataset.pjAutoplay !== '0' && v.autoplay) {
              forceMutedPlay(v);
            }
          } else if (!v.dataset.pjKeepPlaying) {
            if (!v.paused) v.pause();
          }
        });
      },
      { rootMargin: '120px 0px', threshold: [0, 0.05, 0.15, 0.5] }
    );

    function observeVideos() {
      videos().forEach(function (v) {
        if (v.dataset.pjObserved) return;
        v.dataset.pjObserved = '1';
        if (reduceMotion) {
          v.autoplay = false;
          v.removeAttribute('autoplay');
          v.pause();
          return;
        }
        // Ensure muted background loops never show native controls
        if (v.loop) {
          v.muted = true;
          v.setAttribute('muted', '');
          v.removeAttribute('controls');
          forceMutedPlay(v);
          io.observe(v);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeVideos);
    } else {
      observeVideos();
    }
  } else if (reduceMotion) {
    document.addEventListener('DOMContentLoaded', function () {
      videos().forEach(function (v) {
        v.autoplay = false;
        v.pause();
      });
    });
  }
})();
